import { ENV_CONFIG } from './envConfig';

// ***** Code Start BH28072026_1045 - Fail-closed Paddle client key for production
const PLACEHOLDER_KEYS = new Set([
  '',
  'YOUR_LIVE_CLIENT_KEY_HERE',
  'test_your_paddle_key_here',
]);

function isPlaceholderKey(key) {
  if (!key || typeof key !== 'string') return true;
  const trimmed = key.trim();
  if (!trimmed) return true;
  if (PLACEHOLDER_KEYS.has(trimmed)) return true;
  if (trimmed.startsWith('YOUR_')) return true;
  return false;
}

function isProductionBillingMode() {
  // CRA `npm run build` always sets NODE_ENV=production. That is not live billing.
  // Explicit REACT_APP_PADDLE_ENVIRONMENT=production wins even on cantest/dev_server,
  // so live txn_* from llm_server open against checkout.paddle.com (not sandbox).
  const envName = (
    process.env.REACT_APP_ENVIRONMENT ||
    ENV_CONFIG.ENVIRONMENT ||
    ''
  )
    .toString()
    .toLowerCase();
  const paddleEnv = (
    process.env.REACT_APP_PADDLE_ENVIRONMENT ||
    ENV_CONFIG.PADDLE_ENVIRONMENT ||
    ''
  )
    .toString()
    .toLowerCase();
  // ***** Code Start BH10092026_1610 - Explicit paddle production overrides host slot
  if (paddleEnv === 'production' || paddleEnv === 'live') return true;
  if (paddleEnv === 'sandbox' || paddleEnv === 'test') return false;
  if (envName === 'qa' || envName === 'dev_server' || envName === 'development' || envName === 'dev') {
    return false;
  }
  return envName === 'production' || envName === 'prod';
  // ***** Code End BH10092026_1610
}

/**
 * Resolve Paddle client token.
 * Production: never falls back to sandbox test_ keys.
 * Dev / Dev Server: sandbox test_ fallback only when not production billing mode.
 */
export function resolvePaddleClientKey(preferredKey) {
  const key = (preferredKey || process.env.REACT_APP_PADDLE_CLIENT_KEY || ENV_CONFIG.PADDLE_CLIENT_KEY || '')
    .toString()
    .trim();
  const production = isProductionBillingMode();

  if (!isPlaceholderKey(key)) {
    if (production && key.startsWith('test_')) {
      throw new Error(
        'Paddle production mode cannot use a sandbox test_ client key. Set REACT_APP_PADDLE_CLIENT_KEY to a live_ token.'
      );
    }
    return key;
  }

  if (production) {
    throw new Error(
      'Paddle client key missing for production. Set REACT_APP_PADDLE_CLIENT_KEY (live_) in .env.production.'
    );
  }

  // Dev-only sandbox fallback
  return 'test_1027fdb5f8d30d258d4d1586172';
}

export function resolvePaddleEnvironment(clientKey) {
  const configEnvRaw = (
    process.env.REACT_APP_PADDLE_ENVIRONMENT ||
    ENV_CONFIG.PADDLE_ENVIRONMENT ||
    ''
  )
    .toString()
    .toLowerCase();
  if (isProductionBillingMode()) {
    return 'production';
  }
  const isSandboxKey = clientKey && String(clientKey).startsWith('test_');
  if (isSandboxKey || configEnvRaw === 'sandbox') {
    return 'sandbox';
  }
  return configEnvRaw === 'production' ? 'production' : 'sandbox';
}
// ***** Code End BH28072026_1045

// Paddle Configuration - Load from environment variables (fail-closed in production)
function buildPaddleConfig() {
  let clientKey = '';
  let environment = 'sandbox';
  try {
    clientKey = resolvePaddleClientKey();
    environment = resolvePaddleEnvironment(clientKey);
  } catch (err) {
    // Keep module importable; checkout paths must call resolvePaddleClientKey() and surface errors.
    if (typeof console !== 'undefined') {
      console.error('[Paddle]', err && err.message ? err.message : err);
    }
    clientKey = '';
    environment = isProductionBillingMode() ? 'production' : 'sandbox';
  }

  return {
    clientKey,
    environment,
    currency: 'usd',
    // Plan catalog + Paddle pri_* live in DB / server vault — not in the SPA.
  };
}

export const PADDLE_CONFIG = buildPaddleConfig();

export default PADDLE_CONFIG;
